module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('nav', {
    staticClass: "main-submenu header__main-submenu"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isDoctor) ? _c('div', {
    staticClass: "columns small-12 medium-12 large-12"
  }, [_c('ul', {
    staticClass: "main-submenu__list clear_fix"
  }, [_c('li', {
    staticClass: "main-submenu___item"
  }, [_c('router-link', {
    staticClass: "main-submenu__link trans",
    attrs: {
      "activeClass": "main-submenu__active",
      "to": {
        name: "Own",
        params: {
          id: _vm.user._id
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tМой кабинет\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', {
    staticClass: "main-submenu___item"
  }, [_c('router-link', {
    staticClass: "main-submenu__link trans",
    attrs: {
      "activeClass": "main-submenu__active",
      "to": {
        name: "Patients",
        params: {
          clinic: _vm.clinic._id
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tКлиника\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', {
    staticClass: "main-submenu___item"
  }, [_c('router-link', {
    staticClass: "main-submenu__link trans",
    attrs: {
      "activeClass": "main-submenu__active",
      "to": {
        name: "Registry",
        params: {
          clinic: _vm.clinic._id
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tРегистратура\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', {
    staticClass: "main-submenu___item"
  }, [_c('router-link', {
    staticClass: "main-submenu__link trans",
    attrs: {
      "activeClass": "main-submenu__active",
      "to": {
        name: "GeneralSchedule",
        params: {
          clinic: _vm.clinic._id
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tОбщее расписание\n\t\t\t\t\t\t")])], 1)])]) : _c('div', {
    staticClass: "columns small-12 medium-12 large-12"
  }, [_c('ul', {
    staticClass: "main-submenu__list clear_fix"
  }, [_c('li', {
    staticClass: "main-submenu___item"
  }, [_c('router-link', {
    staticClass: "main-submenu__link trans",
    attrs: {
      "activeClass": "main-submenu__active",
      "to": {
        name: "Own",
        params: {
          id: _vm.user._id
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tМой кабинет\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', {
    staticClass: "main-submenu___item"
  }, [_c('router-link', {
    staticClass: "main-submenu__link trans",
    attrs: {
      "activeClass": "main-submenu__active",
      "to": {
        name: "Card"
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tКарточка\n\t\t\t\t\t\t")])], 1)])])])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-465de69f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cabinet/Cabinet.vue
// module id = 608
// module chunks = 0